import PropTypes from 'prop-types'
import styled from 'styled-components'
import Pagination from 'components/Shared/Pagination/Index'

const RowsCountAndPaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const RowsCountWrapper = styled.div`
  display: flex;
  height: 16px;
  padding-top: 16px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`

const RowsCountAndPagination = ({
  countText, activePage, totalPages, isFetching, dataTest = 'rows-count-and-pagination',
}) => {
  return (
    <RowsCountAndPaginationWrapper>
      <RowsCountWrapper data-test={dataTest}>
        {countText}
      </RowsCountWrapper>
      <Pagination
        activePage={activePage}
        totalPages={totalPages}
        disabled={isFetching}
      />
    </RowsCountAndPaginationWrapper>
  )
}

RowsCountAndPagination.propTypes = {
  countText: PropTypes.string.isRequired,
  dataTest: PropTypes.string,
  activePage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  isFetching: PropTypes.bool,
}

export default RowsCountAndPagination
